import { store } from '@betacrew/jars-flux'
export const componentKey = "MANAGE_EXTENSION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setYearList: (state, action) => {
            state.yearList = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedYear: (state, action) => {
            state.selectedYear = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setGridData: (state, action) => {
            state.gridData = action.payload;
        }, 
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        }, 
        setSkip: (state, action) => {
            state.skip = action.payload;
        }, 
        setTotalData: (state, action) => {
            state.totalData = action.payload;
        }, 
        setStatusList: (state, action) => {
            state.statusList = action.payload;
        }, 
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        }, 
        setSelectedExtensionsList: (state, action) => {
            state.selectedExtensions = action.payload;
        },
        setExportFile: (state, action) => {
			state.exportFile = action.payload;
		},
        setFilingFee: (state, action) => {
			state.filingFee = action.payload;
		},
        setShouldReloadExtensionFormsList: (state, action) => {
			state.shouldReloadExtensionFormsList = action.payload;
		},
    }, 
    initialReducerState: {
        loadingState: false,
        payerList: null,
        formList: null,
        yearList: null,
        statusList: null,
        selectedStatus: null,
        selectedYear: null,
        selectedForm: null,
        selectedPayer: null,
        selectedExtensions: [],
        gridData: [],
        rowsPerPage: 10,
        skip: 0,
        totalData: 0,
        filingFee: 0,
        exportFile: {},
        shouldReloadExtensionFormsList: false,
    }
});
export const { setFilingFee, setExportFile, setSelectedExtensionsList, setStatusList, setSelectedStatus, setTotalData, setSkip, setRowsPerPage, setGridData, setSelectedPayer, setSelectedYear, setSelectedForm, setYearList, setFormList, setPayerList, setLoadingState, setShouldReloadExtensionFormsList } = actions;